import { render, staticRenderFns } from "./MyRegistrations.vue?vue&type=template&id=06a2207a&scoped=true"
import script from "./MyRegistrations.vue?vue&type=script&lang=js"
export * from "./MyRegistrations.vue?vue&type=script&lang=js"
import style0 from "./MyRegistrations.vue?vue&type=style&index=0&id=06a2207a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a2207a",
  null
  
)

export default component.exports